import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { members, photos } from '../../data/site';
export function BandSection() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  const lead = members.find(m => m.lead);
  const others = members.filter(m => !m.lead);
  return <section className="bg-paper py-24 text-ink md:py-36" data-id="element-44" data-mp="1dm4tt7cwcczo">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 md:px-8 lg:grid-cols-[1fr_1.1fr] lg:items-center" data-id="element-45" data-mp="1djicig07ej49">
        <div ref={ref} className="relative aspect-[3/4] overflow-hidden rounded-2xl bg-ink" data-id="element-46" data-mp="2p11lkp0gtgaq">
          <motion.img src={photos.julien} alt="Julien Bonnemain, chanteur-guitariste de Téléphomme, en concert" style={{
          y: imgY,
          scale: 1.2
        }} className="h-full w-full object-cover" data-id="element-47" data-mp="2p2uqnzvfjsgm" />
          <div className="absolute bottom-0 left-0 bg-signal px-5 py-3" data-id="element-48" data-mp="jnt78dvwad1d">
            <p className="font-display text-xl uppercase text-paper" data-id="element-49" data-mp="oo75x5blwamq">{lead?.name}</p>
            <p className="text-sm text-paper/80" data-id="element-50" data-mp="tn0hutb8vtks">{lead?.role}</p>
          </div>
        </div>

        <div data-id="element-51" data-mp="tko0oidb9n8s">
          <Reveal data-id="element-52" data-mp="3s4weewur1uf1">
            <h2 className="font-display text-5xl uppercase leading-[0.9] md:text-7xl" data-id="element-53" data-mp="3s5fkngb1eud8">
              Quatre musiciens,
              <br data-id="element-54" data-mp="z4pu1wmepuc" />
              <span className="text-signal" data-id="element-55" data-mp="ymjgcg8uv8p">une seule bombe humaine.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.05} data-id="element-56" data-mp="5vczx0vynsun">
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-ink/70" data-id="element-57" data-mp="aoo8b6gf8hoo">
              Julien Bonnemain porte la voix et la guitare de Téléphomme. Autour de lui, une section rythmique
              rodée par plus de 200 concerts.
            </p>
          </Reveal>

          <ul className="mt-10 border-t border-ink/15" data-id="element-58" data-mp="3eawnbj9yah1s">
            {others.map((m, i) => <Reveal key={m.name} delay={0.08 + i * 0.05} data-id="element-59" data-mp="36ah05h93gwl3" data-mpi={i}>
                <li className="flex items-baseline justify-between gap-4 border-b border-ink/15 py-5" data-id="element-60" data-mp="31cp6ahow30e9">
                  <span className="font-display text-3xl uppercase md:text-4xl" data-id="element-61" data-mp="3g11ugshqjey7">{m.name}</span>
                  <span className="text-sm text-ink/60" data-id="element-62" data-mp="3b4l4rtuw0sj0">{m.role}</span>
                </li>
              </Reveal>)}
          </ul>

          <Link to="/groupe" className="group mt-8 inline-flex items-center gap-2 font-semibold text-ink" data-id="element-63" data-mp="2nfiooqfwj7qm">
            <span className="border-b-2 border-signal pb-0.5" data-id="element-64" data-mp="2xc56t7gufkoy">L’histoire du groupe</span>
            <ArrowUpRightIcon className="h-5 w-5 transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-65" data-mp="2sc92160bnp8c" />
          </Link>
        </div>
      </div>
    </section>;
}